import { render, staticRenderFns } from "./paired.vue?vue&type=template&id=7ec4d6cc&scoped=true"
import script from "./paired.vue?vue&type=script&lang=js"
export * from "./paired.vue?vue&type=script&lang=js"
import style0 from "./paired.vue?vue&type=style&index=0&id=7ec4d6cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec4d6cc",
  null
  
)

export default component.exports